import client from "../client/api";
import { ClientSession } from "../client/clientSession";
import CONSTANTS from "../constants";

const getUser = async () => {

  return client
    .get(`${CONSTANTS.API.PROFILE}/${ClientSession.userTokenPayload.userId}`)
    .then((res) => res.data);
};

export default getUser;
